import {Injectable} from '@angular/core';
import {FORMREQUEST_API_PATH} from '../constants/constants';
import {HttpClient} from '@angular/common/http';
import {Formrequest} from '../model/formrequest';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FormrequestService {

    constructor(protected http: HttpClient) {
    }


    public save(element: Formrequest): Observable<Formrequest> {
        return this.http.post<Formrequest>(FORMREQUEST_API_PATH, element);
    }

}
